export default __webpack_public_path__ + "static/media/extra.f37701ae.svg";